import LoginComponent from "../../Components/login/login";

export default function LoginPage() {

  return (
    <>
      <LoginComponent/>
    </>
  );
}
